// extracted by mini-css-extract-plugin
module.exports = {"panel":"verify-email__panel___duwfz"};